import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { TemplateTEMPObject } from "@services/storage/storeTemplate";
import { logger } from "@services/workers/helpers";
import type { AccountCode, JobTypeCode, TradeCode } from "@utils/BasicTypes";
import type { RootState } from "../../../store";

const storeName = "api";
const nameSpace = "Api Reducer";

export interface Action {
	value: any;
	name?: string;
	body?: {
		settingName: keyof TemplateTEMPObject;
		tradeCode: TradeCode;
		accountCode: AccountCode;
		jobTypeCode: JobTypeCode;
		postcode: string;
		callTypeId: number;
	};
}

export interface IState {
	loading: boolean;
	error: any;
	[key: string]: any;
}

export const initialState: IState = {
	loading: false,
	error: false,
};

export const apiSlice = createSlice({
	name: storeName,
	initialState,
	reducers: {
		start: (state) => {
			state.loading = true;
			state.error = false;
		},
		error: (state) => {
			state.loading = false;
			state.error = true;
		},
		set: (state, action: PayloadAction<Action>) => {
			state.loading = false;
			state.error = false;
			if (action.payload.name)
				state[action.payload.name] = action.payload.value;
		},
		reset: (state, action: PayloadAction<Action>) => {
			logger.debug(nameSpace + "->" + createSlice.name, "API reset");
			return { ...initialState, ...action.payload.value };
		},
	},
});

export const { actions, reducer } = apiSlice;

export const { start, error, set, reset } = actions;

export const apiSelector = (state: RootState) => state.api;

export const apiStateSelector = (state: RootState) => state.api.loading;

export const apiErrorSelector = (state: RootState) => state.api.error;
